import { SortDirection } from '@/shared';
import {
  RequestsFiltersReturn,
  RequestsKpiDetailsFiltersReturn,
} from '../types';

export abstract class RequestsKey {
  static BASE = ['requests'];
  static CLAIMANTS = [...RequestsKey.BASE, 'claimants'];
  static LIST = (
    filters: RequestsFiltersReturn,
    sortBy?: string,
    sortOrder?: SortDirection,
  ) => [
    ...RequestsKey.BASE,
    'list',
    `only-active-${filters.onlyActiveRequests}`,
    filters.filter,
    filters.status,
    sortBy,
    sortOrder,
  ];
  static TOTALS = (onlyActiveRequests: boolean) => [
    ...RequestsKey.BASE,
    'requests-totals',
    `only-active-${onlyActiveRequests}`,
  ];
  static REQUESTS_KPI_DETAILS = (
    filters: RequestsKpiDetailsFiltersReturn,
    sortBy?: string,
    sortOrder?: SortDirection,
    pageNumber?: number,
  ) => [
    ...RequestsKey.BASE,
    'requests-kpi-details',
    `only-active-${filters.onlyActiveRequests}`,
    filters.filter,
    sortBy,
    sortOrder,
    pageNumber,
  ];
  static DETAILS = (id: number) => [...RequestsKey.BASE, 'request-details', id];
  static ACTIVITIES = (id: number) => [
    ...RequestsKey.DETAILS(id),
    'activities',
  ];
}
